/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Menu_MobileInputs */

const en_control_menu_mobile = /** @type {(inputs: Control_Menu_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile`)
};

const zh_control_menu_mobile = /** @type {(inputs: Control_Menu_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移动导航`)
};

/**
* | output |
* | --- |
* | "Mobile" |
*
* @param {Control_Menu_MobileInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_menu_mobile = /** @type {((inputs?: Control_Menu_MobileInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Menu_MobileInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_menu_mobile(inputs)
	return zh_control_menu_mobile(inputs)
});
export { control_menu_mobile as "control.menu.mobile" }